module.exports = require('./helpers/bundle-url').getBundleURL('8qGB4') + "logo-dark.eefe0b7f.svg";